<template>
  <div>
    <hero></hero>
    <programs2></programs2>
    <l-footer></l-footer>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>